/** Auto-accept karet v Codable chatu (plan / patch / commit). */

export function djb2Hash(s: string): number {
  let h = 5381;
  for (let j = 0; j < s.length; j++) h = ((h << 5) + h + s.charCodeAt(j)) | 0;
  return h;
}

/** Stejný klíč jako stream-end accept plánu i PlanCard. */
export function planAutoClaimKey(content: string): string {
  return `plan:${djb2Hash(content.trim())}`;
}

/** Stabilní klíč bloku (obsah + pozice v rendereru). */
export function blockAutoClaimKey(
  kind: string,
  content: string,
  index: number,
): string {
  return `${kind}:${index}:${djb2Hash(content)}`;
}

export function chatAutoDoneStorageKey(projectId: string): string {
  return `acm_codable_auto_done_${projectId}`;
}

export function loadChatAutoDone(projectId: string): Set<string> {
  if (typeof window === 'undefined') return new Set();
  try {
    const parsed = JSON.parse(
      window.localStorage.getItem(chatAutoDoneStorageKey(projectId)) ?? '[]',
    );
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((x): x is string => typeof x === 'string'));
  } catch {
    return new Set();
  }
}

export function persistChatAutoDone(projectId: string, keys: Set<string>): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(
      chatAutoDoneStorageKey(projectId),
      JSON.stringify([...keys].slice(-300)),
    );
  } catch { /* quota */ }
}

export type ChatAutoCardUi = 'buttons' | 'apply' | 'done';

/**
 * Jak má karta vypadat.
 * Claimed = už auto/ručně vyřízeno (i po reloadu) → badge, ne Přijmout/Odmítnout.
 * autoApply po streamu → aplikovat; pending → ještě ne (fence je zamaskovaný).
 */
export function chatAutoCardUi(opts: {
  claimed: boolean;
  autoApply: boolean;
  pending?: boolean;
}): ChatAutoCardUi {
  if (opts.claimed) return 'done';
  if (opts.autoApply && !opts.pending) return 'apply';
  return 'buttons';
}
